import React from 'react';
import SolutionInstallSuccessContainer from 'containers/SolutionInstallSuccessContainer';

export default function SolutionInstallSuccessPage() {
  return <SolutionInstallSuccessContainer />;
}
